import _ from "lodash";
import moment from "moment";
import Vue from "vue";
import "./plugins/vuetify";
// import * as Sentry from "@sentry/browser";
// import { Vue as VueIntegration } from "@sentry/integrations";
import VueExcelXlsx from "vue-excel-xlsx";

// sync localstorage with store
import lsSync from "./utils/lsSync";
lsSync.syncData();

import App from "./App.vue";
import "./assets/sass/_variables.scss";
import "./plugins/axios";
import router from "./router";
import store from "./store";
import common from "./utils/common";

import VueAwesomeSwiper from "vue-awesome-swiper";
import VueRangedatePicker from "vue-rangedate-picker";

// If you use Swiper 6.0.0 or higher
import "swiper/css/swiper.css";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";

Vue.use(VueAwesomeSwiper /* { default options with global component } */);
Vue.use(VueRangedatePicker);

// Sentry.init({
//   dsn: process.env.VUE_APP_SENTRY_DSN,
//   integrations: [
//     new VueIntegration({
//       Vue,
//       tracing: true,
//     }),
//     new Integrations.BrowserTracing(),
//   ],
//
//   // We recommend adjusting this value in production, or using tracesSampler
//   // for finer control
//   tracesSampleRate: 1.0,
// });

import VueClipboard from "vue-clipboard2";

VueClipboard.config.autoSetContainer = true; // add this line
Vue.use(VueClipboard);
Vue.use(VueExcelXlsx);

// global compponents
import bBtn from "./components/common/b-btn";
import vTextareaAutocomplete from "./components/common/v-textarea-autocomplete";
import Default from "./layouts/Default";
import NoSidebar from "./layouts/NoSidebar";
import TopHeader from "./layouts/TopHeader";
import authLayout from "./layouts/authLayout";

import VueHighlightJS from "vue-highlightjs";
Vue.use(VueHighlightJS);

const getEnv = (key) =>
  process.env.VUE_APP_CURRENT_ENV !== "production"
    ? process.env[`VUE_APP_${key}`]
    : window.__ENV__[`VUE_APP_${key}`];

// Usage
const currentEnv = getEnv("CURRENT_ENV");

Vue.config.productionTip = false;

Vue.component("default-layout", Default);
Vue.component("no-sidebar-layout", NoSidebar);
Vue.component("TopHeader-layout", TopHeader);
Vue.component("auth-layout", authLayout);
Vue.component("vTextareaAutocomplete", vTextareaAutocomplete);
Vue.component("vTextareaAutocomplete", vTextareaAutocomplete);
Vue.component("b-btn", bBtn);

Vue.component("v-style", {
  render: function (createElement) {
    return createElement("style", this.$slots.default);
  },
});
// Adding moment and lodash to vue instance pt
Vue.prototype.$moment = moment;
Vue.prototype.$_ = _;

Vue.config.errorHandler = function (error, vm, info) {
  // err: error object
  // vm: the Vue component instance where the error occurred
  // info: a Vue-specific error message, e.g. lifecycle hook name
  // Log the error (you can also send it to an external error-reporting service)

  if (currentEnv !== "production") {
    console.log("[Vue Error Handler]", error, info);
  }

  let text = "";
  console.log("ENV:", currentEnv);

  store.dispatch("setLoader", false);
  store.dispatch("setSavingStatus", false);

  if (error.name == "AxiosError") {
    const requestId = error.config.headers["x-request-id"];

    if (error.message == "Network Error") {
      text = `Network Error.`;
      if (requestId) {
        text += `Reference Code: ${requestId}`;
      }
    } else {
      const errorResponse = error.response;

      if (errorResponse && errorResponse.status === 401) {
        text += `Unauthenticated request.`;

        common.logOut();
      } else if (errorResponse && errorResponse.status === 404) {
        router.push({ name: "NotFound" });
      } else if (errorResponse && errorResponse.status === 500) {
        text +=
          currentEnv == "production"
            ? `Something went wrong, please try again!`
            : error;
      } else if (errorResponse && errorResponse.status === 400) {
        text +=
          errorResponse.data.message ||
          "Something went wrong, please try again!";
      } else {
        text +=
          currentEnv == "production"
            ? `Something went wrong, please try again!`
            : error;
      }
    }
  } else {
    text +=
      currentEnv == "production"
        ? `Something went wrong, please try again!`
        : error;
  }

  store.dispatch("setErrorSnackbar", {
    text,
  });
};

window.addEventListener("unhandledrejection", function (event) {
  //handle error here
  //event.promise contains the promise object
  //event.reason contains the reason for the rejection

  if (currentEnv !== "production") {
    console.log("[Vue Unhandled Rejection]", event);
  }

  store.dispatch("setLoader", false);
  store.dispatch("setSavingStatus", false);

  store.dispatch("setErrorSnackbar", {
    text:
      currentEnv == "production"
        ? `Something went wrong, please try again!`
        : event.reason,
  });
});

window.App = new Vue({
  router,
  store,
  common,
  render: (h) => h(App),
}).$mount("#app");
